module.exports = __webpack_public_path__ + "img/001整体.513e71e6.jpg";